// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-input-group-addons .input-btn {
  padding: 0 6px;
}

.provably-fair-body .nav-pills {
  border-bottom: 1px solid var(--zinc-700);
}
.provably-fair-body .nav-pills .nav-item {
  width: 50%;
  text-align: center;
}
.provably-fair-body .nav-pills .nav-item .nav-link {
  width: 100%;
  text-align: center;
  position: relative;
  padding-bottom: 20px;
}
.provably-fair-body .nav-pills .nav-item .nav-link.active {
  background-color: transparent;
}
.provably-fair-body .nav-pills .nav-item .nav-link.active:after {
  position: absolute;
  content: " ";
  background-color: var(--buttonBg);
  height: 5px;
  left: 0;
  bottom: 0;
  width: 100%;
  border-radius: 0;
}
.provably-fair-body .nav-link {
  color: var(--white);
  font-weight: 500;
}
.provably-fair-body .nav-link:focus,
.provably-fair-body .nav-link:hover {
  color: var(--white);
}
.provably-fair-body .nav-link:focus-visible {
  outline: none;
}

.verify-result-section {
  word-break: break-all;
  padding: 1rem;
  border: 1px solid gray;
  width: 100%;
  border-radius: 10px;
}

.verify-result-border-container {
  border: 1px solid rgba(236, 236, 236, 0.25);
  border-radius: 4px;
  background: var(--DarkRed);
  padding: 2rem 0rem;
}

.custom-input-group-addons {
  display: flex;
  justify-content: center;
  align-items: center;
}
.custom-input-group-addons button {
  border: 0;
  background-color: transparent;
}
.custom-input-group-addons button svg {
  fill: var(--white);
}

.verify-btn {
  border-radius: 8px;
  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%);
  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.4), 0px 1px 0px 0px rgba(239, 116, 3, 0.6) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.3) inset, 0px 0px 15px 0px #EF7403 inset;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  border: 0;
  padding: 10px 10px;
  min-height: 41px;
}

.verify-result-slider-box .slider-box {
  background-color: #453f02;
  width: fit-content;
  margin: 0 auto;
  padding: 1rem 3rem;
  border-radius: 0.375rem;
}

.btn.btn-secondary.generate-btn {
  min-height: 37px;
  border-radius: 0.375rem;
  font-weight: bold;
}

.border-section {
  border-radius: 4px;
  border: 1px solid var(--Zinc-800, #27272A);
  padding: 80px 20px 20px 20px;
}
.border-section .form-box .form-label {
  color: #a1a1a1;
  font-size: 14px;
  font-weight: 400;
}

#mines-fairness-popup .modal-dialog {
  width: 640px;
  max-width: 640px;
}
@media screen and (max-width: 767.98px) {
  #mines-fairness-popup .modal-dialog {
    width: 100%;
    max-width: 100%;
  }
}
#mines-fairness-popup .modal-body {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: top center;
  padding: 16px 24px;
}
#mines-fairness-popup .heading-wrap h5 {
  width: fit-content;
}
#mines-fairness-popup .btn-close {
  filter: invert(1);
  color: transparent;
  opacity: 1;
  cursor: pointer;
  background-position: right;
  position: absolute;
  top: 15px;
  right: 25px;
  width: fit-content;
  z-index: 9;
}
#mines-fairness-popup .btn-close:focus {
  outline: none !important;
  box-shadow: none !important;
}
#mines-fairness-popup .heading-wrap {
  text-align: center;
}

ul.box-detail {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0;
  margin: 20px 0;
  gap: 16px;
  border: 1px solid var(--Zinc-800, #27272A);
  border-left: 0;
  border-right: 0;
}
ul.box-detail li {
  background-color: var(--TabBgActive);
  border-radius: 0.5rem;
  width: calc(33.3333333333% - 16px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem 0;
}
@media screen and (max-width: 574.98px) {
  ul.box-detail li {
    width: 100%;
  }
}
ul.box-detail li:nth-child(2) {
  border-left: 1px solid var(--Zinc-800, #27272A);
  border-right: 1px solid var(--Zinc-800, #27272A);
  border-radius: 0;
}
ul.box-detail li p {
  padding: 0;
  margin: 0;
  font-size: 16px;
}
ul.box-detail li p:nth-child(1) {
  color: #a1a1a1;
}
ul.box-detail li p:nth-child(2) {
  color: #fff;
}

ul.user-detail .provably-text p {
  font-size: 14px;
}
ul.user-detail .provably-text span {
  color: #a1a1a1;
}

.play-btn {
  background-color: #fff;
  padding: 1rem;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  margin-top: 1.5rem;
  border-radius: 4px;
  gap: 0.5rem;
}

.slider-box {
  width: 100%;
  background-color: #242837;
  padding: 0.5rem 0.5rem;
  border-radius: 50px;
  position: relative;
}
@media screen and (max-width: 991px) {
  .slider-box {
    margin-bottom: 5rem;
  }
}
@media screen and (max-width: 374px) {
  .slider-box {
    margin-bottom: 3.75rem;
  }
}
.slider-box .slider-scale {
  position: absolute;
  left: 0;
  right: 0;
  top: -40px;
  margin: 0 0.75rem 0.375rem !important;
}
.slider-box .slider-scale > span {
  text-align: center;
  width: 1.563rem;
  position: relative;
}
.slider-box .slider-scale > span::after {
  content: "";
  display: inline-block;
  left: 50%;
  position: absolute;
  top: 35px;
  border-style: solid;
  border-width: 0 0 1.125rem 1.125rem;
  height: 0;
  width: 0;
  border-color: transparent;
  border-bottom-color: #242837;
  transform: translateX(-50%) rotate(-135deg);
}
@media screen and (min-width: 767px) {
  .slider-box .slider-scale {
    margin: 0 2.5rem 0.375rem;
  }
}
.slider-box .inner-box {
  width: 100%;
  background-color: var(--zinc-900);
  border-radius: 50px;
  position: relative;
  padding: 0.5rem;
}
.slider-box .inner-box .dice-img-box {
  width: 4.063rem;
  height: auto;
  position: absolute;
  top: -5.1rem;
  left: 0;
  transform: scale(0.5);
  opacity: 0;
  transition: all 0.3s ease-in-out;
}
.slider-box .inner-box .dice-img-box.dice-animation {
  transition: all 0.3s ease-in-out;
  transform: scale(1.15);
}
.slider-box .inner-box .dice-img-box.show-result {
  animation: 0.5s ease-out 0s 1 normal none running show-result;
  transform: scale(1);
  opacity: 1;
}
.slider-box .inner-box .dice-img-box .img-flame {
  position: absolute;
  left: 0.25rem;
  height: 145%;
  bottom: 3.125rem;
}
.slider-box .inner-box .dice-img-box .dice-status {
  font-size: 1.25rem;
  font-weight: 700;
  text-align: center;
  position: absolute;
  top: 49%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transition: all 500ms ease-in-out;
}
.slider-box .inner-box .dice-img-box .status-win {
  color: #57af20;
}
.slider-box .inner-box .dice-img-box .status-lose {
  color: #e73232;
}
.slider-box .inner-box .rangeslider {
  background: #6CF96C;
}
.slider-box .inner-box .rangeslider--horizontal {
  height: 0.375rem;
}
.slider-box .inner-box .rangeslider__fill {
  background-color: #D32C46;
}
.slider-box .inner-box .rangeslider__handle,
.slider-box .inner-box .rangeslider--active .rangeslider__handle,
.slider-box .inner-box .rangeslider__handle:active {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.25rem;
  box-shadow: 0px 3.56229px 3.56229px rgba(0, 0, 0, 0.25);
}
.slider-box .inner-box .rangeslider--horizontal .rangeslider__handle {
  top: -10px;
}
.slider-box .inner-box .rangeslider--horizontal .rangeslider__handle:active {
  transform: scale(0.95);
}
.slider-box .inner-box .rangeslider__handle:after {
  display: none;
}
.slider-box .inner-box .rangeslider,
.slider-box .inner-box input[type=range] {
  max-width: 100%;
}
.slider-box .inner-box .rangeslider__ruler {
  color: var(--white);
  font-size: 0.875rem;
  text-align: justify;
  cursor: pointer;
  margin: 0 0.188rem 0;
  position: relative;
  top: -3.438rem;
}
.slider-box .inner-box .rangeslider__ruler:after {
  content: "";
  display: inline-block;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/OneToOneGameFairnessModal/FairnessModal.scss"],"names":[],"mappings":"AAgBE;EACE,cAAA;AAfJ;;AAoBE;EACE,wCAAA;AAjBJ;AAmBI;EACE,UAAA;EACA,kBAAA;AAjBN;AAmBM;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;AAjBR;AAmBQ;EACE,6BAAA;AAjBV;AAmBU;EACE,kBAAA;EACA,YAAA;EACA,iCAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AAjBZ;AAgCE;EACE,mBAAA;EACA,gBAAA;AA9BJ;AAiCE;;EAEE,mBAAA;AA/BJ;AAkCE;EACE,aAAA;AAhCJ;;AAoCA;EAEE,qBAAA;EACA,aAAA;EACA,sBAAA;EAEA,WAAA;EACA,mBAAA;AAnCF;;AAuCA;EACE,2CAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;AApCF;;AAuCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AApCF;AAsCE;EACE,SAAA;EACA,6BAAA;AApCJ;AAsCI;EACE,kBAAA;AApCN;;AAyCA;EA5GE,kBAAA;EACA,6DAAA;EACA,kLAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AAuEF;;AA+BA;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;AA5BF;;AA+BA;EACE,gBAAA;EACA,uBAAA;EACA,iBAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,0CAAA;EACA,4BAAA;AA5BF;AA8BI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA5BN;;AAmCE;EACE,YAAA;EACA,gBAAA;AAhCJ;AAiCI;EAHF;IAII,WAAA;IACA,eAAA;EA9BJ;AACF;AAiCE;EAEE,4BAAA;EACA,0BAAA;EACA,+BAAA;EACA,kBAAA;AAhCJ;AAqCI;EACE,kBAAA;AAnCN;AAuCE;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AArCJ;AAuCI;EACE,wBAAA;EACA,2BAAA;AArCN;AAyCE;EACE,kBAAA;AAvCJ;;AA2CA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;EACA,0CAAA;EACA,cAAA;EACA,eAAA;AAxCF;AA0CE;EACE,oCAAA;EACA,qBAAA;EACA,kCAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAxCJ;AAyCI;EATF;IAUI,WAAA;EAtCJ;AACF;AAwCI;EACE,+CAAA;EACA,gDAAA;EACA,gBAAA;AAtCN;AAyCI;EACE,UAAA;EACA,SAAA;EACA,eAAA;AAvCN;AAyCM;EACE,cAAA;AAvCR;AA0CM;EACE,WAAA;AAxCR;;AAgDI;EACE,eAAA;AA7CN;AAgDI;EACE,cAAA;AA9CN;;AAmDA;EACE,sBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AAhDF;;AAoDA;EACE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAjDF;AAmDE;EAPF;IAQI,mBAAA;EAhDF;AACF;AAkDE;EAXF;IAYI,sBAAA;EA/CF;AACF;AAiDE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,qCAAA;AA/CJ;AAiDI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AA/CN;AAiDM;EACE,WAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,mCAAA;EACA,SAAA;EACA,QAAA;EACA,yBAAA;EACA,4BAAA;EACA,2CAAA;AA/CR;AAmDI;EA5BF;IA6BI,yBAAA;EAhDJ;AACF;AAmDE;EACE,WAAA;EACA,iCAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAjDJ;AAmDI;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EAEA,qBAAA;EACA,UAAA;EACA,gCAAA;AAlDN;AAoDM;EACE,gCAAA;EAEA,sBAAA;AAnDR;AAsDM;EACE,6DAAA;EACA,mBAAA;EACA,UAAA;AApDR;AAuDM;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AArDR;AAwDM;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;EACA,iCAAA;AAtDR;AAyDM;EACE,cAAA;AAvDR;AA0DM;EACE,cAAA;AAxDR;AA4DI;EACE,mBAAA;AA1DN;AA6DI;EACE,gBAAA;AA3DN;AA8DI;EACE,yBAAA;AA5DN;AA+DI;;;EAGE,aAAA;EACA,cAAA;EAKA,sBAAA;EACA,uDAAA;AAjEN;AAoEI;EACE,UAAA;AAlEN;AAoEM;EACE,sBAAA;AAlER;AAsEI;EACE,aAAA;AApEN;AAuEI;;EAEE,eAAA;AArEN;AAwEI;EACE,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;AAtEN;AAyEI;EACE,WAAA;EACA,qBAAA;EACA,WAAA;AAvEN","sourcesContent":["@mixin BetButton {\n  border-radius: 8px;\n  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%);\n  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.40), 0px 1px 0px 0px rgba(239, 116, 3, 0.60) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.30) inset, 0px 0px 15px 0px #EF7403 inset;\n  color: #FFF;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 150%;\n  border: 0;\n  padding: 10px 10px;\n  min-height: 41px;\n}\n\n.custom-input-group-addons {\n  .input-btn {\n    padding: 0 6px;\n  }\n}\n\n.provably-fair-body {\n  .nav-pills {\n    border-bottom: 1px solid var(--zinc-700);\n\n    .nav-item {\n      width: 50%;\n      text-align: center;\n\n      .nav-link {\n        width: 100%;\n        text-align: center;\n        position: relative;\n        padding-bottom: 20px;\n\n        &.active {\n          background-color: transparent;\n\n          &:after {\n            position: absolute;\n            content: \" \";\n            background-color: var(--buttonBg);\n            height: 5px;\n            left: 0;\n            bottom: 0;\n            width: 100%;\n            border-radius: 0;\n            ;\n          }\n        }\n      }\n    }\n  }\n\n  // .nav-pills .nav-link.active,\n  // .nav-pills .show>.nav-link {\n  //   background-color: var(--gray-800);\n  //   // border: 1px solid var(--game-border-200);\n  //   border: none;\n  // }\n\n  .nav-link {\n    color: var(--white);\n    font-weight: 500;\n  }\n\n  .nav-link:focus,\n  .nav-link:hover {\n    color: var(--white);\n  }\n\n  .nav-link:focus-visible {\n    outline: none;\n  }\n}\n\n.verify-result-section {\n  // overflow-y: scroll;\n  word-break: break-all;\n  padding: 1rem;\n  border: 1px solid gray;\n  // height: 200px;\n  width: 100%;\n  border-radius: 10px;\n}\n\n\n.verify-result-border-container {\n  border: 1px solid rgba(236,236,236,0.25);\n  border-radius: 4px;\n  background: var(--DarkRed);\n  padding: 2rem 0rem;\n}\n\n.custom-input-group-addons {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  button {\n    border: 0;\n    background-color: transparent;\n\n    svg {\n      fill: var(--white);\n    }\n  }\n}\n\n.verify-btn {\n  @include BetButton();\n}\n\n\n.verify-result-slider-box .slider-box {\n  background-color: #453f02;\n  width: fit-content;\n  margin: 0 auto;\n  padding: 1rem 3rem;\n  border-radius: 0.375rem;\n}\n\n.btn.btn-secondary.generate-btn {\n  min-height: 37px;\n  border-radius: 0.375rem;\n  font-weight: bold;\n}\n\n.border-section {\n  border-radius: 4px;\n  border: 1px solid var(--Zinc-800, #27272A);\n  padding: 80px 20px 20px 20px;\n  .form-box {\n    .form-label {\n      color: #a1a1a1;\n      font-size: 14px;\n      font-weight: 400;\n    }\n  }\n}\n\n\n#mines-fairness-popup {\n  .modal-dialog {\n    width: 640px;\n    max-width: 640px;\n    @media screen and (max-width: 767.98px) {\n      width: 100%;\n      max-width: 100%;\n    }\n  }\n\n  .modal-body {\n    // background-image: url('../../../../public/assets/images/stock-images/modal-bg-1.png');\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    background-position: top center;\n    padding: 16px 24px;\n    // background-color: #0A0A0D;\n  }\n\n  .heading-wrap {\n    h5 {\n      width: fit-content;\n    }\n  }\n\n  .btn-close {\n    filter: invert(1);\n    color: transparent;\n    opacity: 1;\n    cursor: pointer;\n    background-position: right;\n    position: absolute;\n    top: 15px;\n    right: 25px;\n    width: fit-content;\n    z-index: 9;\n\n    &:focus {\n      outline: none !important;\n      box-shadow: none !important;\n    }\n  }\n\n  .heading-wrap {\n    text-align: center;\n  }\n}\n\nul.box-detail {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  padding: 0;\n  margin: 20px 0;\n  gap: 16px;\n  border: 1px solid var(--Zinc-800, #27272A);\n  border-left: 0;\n  border-right: 0;\n\n  li {\n    background-color: var(--TabBgActive);\n    border-radius: 0.5rem;\n    width: calc(100% / 3 - 16px);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem 0;\n    @media screen and (max-width: 574.98px) {\n      width: 100%;\n      // gap: 1rem;\n    }\n    &:nth-child(2) {\n      border-left: 1px solid var(--Zinc-800, #27272A);\n      border-right: 1px solid var(--Zinc-800, #27272A);\n      border-radius: 0;\n    }\n\n    p {\n      padding: 0;\n      margin: 0;\n      font-size: 16px;\n\n      &:nth-child(1) {\n        color: #a1a1a1;\n      }\n\n      &:nth-child(2) {\n        color: #fff;\n      }\n    }\n  }\n}\n\nul.user-detail {\n  .provably-text {\n    p {\n      font-size: 14px;\n    }\n\n    span {\n      color: #a1a1a1;\n    }\n  }\n}\n\n.play-btn {\n  background-color: #fff;\n  padding: 1rem;\n  font-size: 14px;\n  font-weight: 500;\n  color: #000;\n  margin-top: 1.5rem;\n  border-radius: 4px;\n  gap: 0.5rem;\n}\n\n\n.slider-box {\n  width: 100%;\n  background-color: #242837;\n  padding: 0.5rem 0.5rem;\n  border-radius: 50px;\n  position: relative;\n\n  @media screen and (max-width: 991px) {\n    margin-bottom: 5rem;\n  }\n\n  @media screen and (max-width: 374px) {\n    margin-bottom: 3.75rem;\n  }\n\n  .slider-scale {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: -40px;\n    margin: 0 0.75rem 0.375rem !important;\n\n    &>span {\n      text-align: center;\n      width: 1.563rem;\n      position: relative;\n\n      &::after {\n        content: \"\";\n        display: inline-block;\n        left: 50%;\n        position: absolute;\n        top: 35px;\n        border-style: solid;\n        border-width: 0 0 1.125rem 1.125rem;\n        height: 0;\n        width: 0;\n        border-color: transparent;\n        border-bottom-color: #242837;\n        transform: translateX(-50%) rotate(-135deg);\n      }\n    }\n\n    @media screen and (min-width: 767px) {\n      margin: 0 2.5rem 0.375rem;\n    }\n  }\n\n  .inner-box {\n    width: 100%;\n    background-color: var(--zinc-900);\n    border-radius: 50px;\n    position: relative;\n    padding: 0.5rem;\n\n    .dice-img-box {\n      width: 4.063rem;\n      height: auto;\n      position: absolute;\n      top: -5.1rem;\n      left: 0;\n      // display: none;\n      transform: scale(0.5);\n      opacity: 0;\n      transition: all 0.3s ease-in-out; //, 0.6s ease-in-out;\n\n      &.dice-animation {\n        transition: all 0.3s ease-in-out;\n        // transition-delay: 0.4s;\n        transform: scale(1.15);\n      }\n\n      &.show-result {\n        animation: 0.5s ease-out 0s 1 normal none running show-result;\n        transform: scale(1);\n        opacity: 1;\n      }\n\n      .img-flame {\n        position: absolute;\n        left: 0.25rem;\n        height: 145%;\n        bottom: 3.125rem;\n      }\n\n      .dice-status {\n        font-size: 1.25rem;\n        font-weight: 700;\n        text-align: center;\n        position: absolute;\n        top: 49%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        -webkit-transform: translate(-50%, -50%);\n        -moz-transform: translate(-50%, -50%);\n        -ms-transform: translate(-50%, -50%);\n        -o-transform: translate(-50%, -50%);\n        transition: all 500ms ease-in-out;\n      }\n\n      .status-win {\n        color: #57af20;\n      }\n\n      .status-lose {\n        color: #e73232;\n      }\n    }\n\n    .rangeslider {\n      background: #6CF96C;\n    }\n\n    .rangeslider--horizontal {\n      height: 0.375rem;\n    }\n\n    .rangeslider__fill {\n      background-color: #D32C46;\n    }\n\n    .rangeslider__handle,\n    .rangeslider--active .rangeslider__handle,\n    .rangeslider__handle:active {\n      width: 1.5rem;\n      height: 1.5rem;\n      // background: url(\"../../../../src/games/Limbo/GameTheme/LimboGame/images/slider-thumb.svg\") #ffffff;\n      // background-repeat: no-repeat;\n      // background-position: center;\n      // background-size: 50%;\n      border-radius: 0.25rem;\n      box-shadow: 0px 3.56229px 3.56229px rgba(0, 0, 0, 0.25);\n    }\n\n    .rangeslider--horizontal .rangeslider__handle {\n      top: -10px;\n\n      &:active {\n        transform: scale(0.95);\n      }\n    }\n\n    .rangeslider__handle:after {\n      display: none;\n    }\n\n    .rangeslider,\n    input[type=\"range\"] {\n      max-width: 100%;\n    }\n\n    .rangeslider__ruler {\n      color: var(--white);\n      font-size: 0.875rem;\n      text-align: justify;\n      cursor: pointer;\n      margin: 0 0.188rem 0;\n      position: relative;\n      top: -3.438rem;\n    }\n\n    .rangeslider__ruler:after {\n      content: \"\";\n      display: inline-block;\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
